import React, { useState } from 'react';
import moment from 'moment';
import { useAppContext } from '../../../../Services/AppContext';
import ElectronicPrescriptionDetailLatam from './Latam/ElectronicPrescriptionDetailLatam';
import useNotification from '../../../../Hooks/useNotification.hook';
import apiClient from '../../../../Services/ApiClient';
import OverlayLoading from '../../../../Components/OverlayLoading';
import { useIsLatam } from '../../../Region/Services/region.service';
import EPrescriptionWrapper from '../../../EPrescription/Components/EPrescriptionWrapper';
import useTranslation from '../../../../Hooks/useTranslation';
import { usePatientTreatmentContext } from '../../../Patient/Components/PatientTreatment/ContextProvider';
import { useDiscourseContext } from '../../../Discourse/Services/DiscourseContext';

interface Props {
	onSubmit?: any;
	onClose?: () => void;
	onCreate?: () => void;
	patientId: string;
	defaultValues?: any;
	attachToDiscourse?: boolean;
	disableSubmit?: boolean;
	createDekurz?: boolean;
}

const ElectronicPrescriptionDetailWrapper: React.FC<Props> = ({
	onSubmit,
	onClose,
	onCreate,
	patientId,
	defaultValues,
	attachToDiscourse = false,
	disableSubmit,
	createDekurz = true,
}) => {
	const { t } = useTranslation();
	const { globalTemplate } = useAppContext();
	const { caseId } = usePatientTreatmentContext();

	const { showNotificationAlert, showNotificationSuccess } = useNotification();
	const [isProcessing, setIsProcessing] = useState<boolean>(false);
	const { handleAttachPrescription } = useDiscourseContext();

	const handleSubmitLatam = async (values: any) => {
		setIsProcessing(true);
		try {
			setIsProcessing(true);

			let finalValues = {
				patientId: patientId,
				type: 'default',
				caseId,
				default: {
					items: values.medicaments ? values.medicaments : [],
					validUntil: values.expirationDate,
					nonPharmacologicalTreatment: values.nonPharmacologicalTreatment
						? values.nonPharmacologicalTreatment
						: '',
				},
				createDekurz,
				attachToDraftDiscourse: attachToDiscourse,
				addToPatientECard: values.addToPatientECard,
			};

			let result = await apiClient.post('/prescription/', finalValues);
			if (result) {
				if (attachToDiscourse && handleAttachPrescription && result.data?.id) {
					await handleAttachPrescription(result.data.id);
				}

				if (onClose) {
					await onClose();
				}
				showNotificationSuccess({
					content: t('base.ePrescriptionCreated'),
				});
			} else {
				if (onClose) {
					await onClose();
				}
			}
		} catch (e: any) {
			if (e.response.data.displayableError) {
				showNotificationAlert({
					content: e.response.data.message,
				});
			}
		} finally {
			setIsProcessing(false);
		}
		onSubmit?.();
		setIsProcessing(false);
	};

	const handleOnCreate = () => {
		onClose?.();
		onCreate?.();
	};

	switch (globalTemplate) {
		default:
			return (
				<EPrescriptionWrapper
					onPrescriptionCreated={handleOnCreate}
					customOnSubmit={onSubmit}
					patientId={patientId}
					defaultValues={defaultValues}
					setIsLoading={setIsProcessing}
				/>
			);
		case 'peru':
		case 'ecuador':
		case 'mexico':
		case 'colombia':
			return (
				<div style={{ position: 'relative' }}>
					<ElectronicPrescriptionDetailLatam
						onSubmit={onSubmit ? onSubmit : handleSubmitLatam}
						defaultValues={defaultValues}
						disableSubmit={disableSubmit}
					/>
					{isProcessing && <OverlayLoading />}
				</div>
			);
	}
};

export default ElectronicPrescriptionDetailWrapper;
